module.exports = __webpack_public_path__ + "images/logo_pandora.6d2adc6232e43830d33e86b251367c02.png";